export function getRequestId(progressUri: string) {
	const pattern = new RegExp(/cloud\/[\w-]+\/status\/([\w-]+)$/);
	const matches = pattern.exec(progressUri);
	return matches ? matches[1] : '';
}
